import React, { useEffect, useState } from 'react'
import axios from 'axios';
import config from '../config';
import { Button, Row, Col } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import PdfViewing from './PdfViewing';

const studentCreation2 = [
    {
        "img": '/img/magazine/studcre2.jpeg',
        "Title": "எண்ணும் எழுத்தும்",   
        "Description": "தேவகோட்டை, தே பிரித்தோ மேல்நிலைப்பள்ளி இளமைக்கனல், வாசிப்பு இயக்க மாணாக்கரின் கதைநூல்",
         "pdfUrl": "/img/magazine/EEwriteup.pdf",
    }
]

const resolveAsset = (value, folder) => {
  if (!value) return '';
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('/')) return value;
  return `${folder}/${value}`;
};
const studentCreation = [
    {
        "img": '/img/magazine/studcre.jpg',
        "Title": "இராசாத்தி",   
        "Description": "மதுரை, தூய மரியன்னை மேல்நிலைப் பள்ளியின் இளமைக்கனல் எழுத்தாளர் இயக்க முன்னாள் மாணவர் படைப்பு..",
         
    },
]
export default function CurrentIssue() {
  const [magazine, setMagazine] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMagazine = async () => {
      setLoading(true);
      setError('');

      const getReportDate = (item) => {
        const dateValue = item.reportDate || item.updatedOn || item.createdOn || item.updatedDate || item.reportdate || item.updatedon;
        const parsed = dateValue ? new Date(dateValue) : null;
        return parsed && !Number.isNaN(parsed.valueOf()) ? parsed : new Date(0);
      };

      try {
        const fetchKey = 'Kanal';
        const fetchOption = 'ReportCategory';
        const response = await axios.get(`${config.api.invokeURL}/website/reports?fetchKey=${fetchKey}&fetchOption=${fetchOption}`, {
          headers: {
            'x-api-key': config.api.key,
          },
        });

        const rawData = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        const sorted = [...rawData].sort((a, b) => getReportDate(b) - getReportDate(a));
        const latestDate = sorted.length > 0 ? getReportDate(sorted[0]).valueOf() : null;
        const latestItems = latestDate !== null
          ? sorted.filter((item) => getReportDate(item).valueOf() === latestDate)
          : [];

        setMagazine(latestItems);
      } catch (fetchError) {
        console.error('Failed to load magazine details:', fetchError);
        setError('Unable to load magazine details from API.');
      } finally {
        setLoading(false);
      }
    };

    fetchMagazine();
  }, []);

  return (
    <div className='container' >
       <Row>
       <h2 className='my-4' style={{fontWeight:"500"}}>Current Issue</h2>
        {loading && <div className='text-muted mb-3'>Loading magazine details...</div>}
        {error && <div className='text-danger mb-3'>{error}</div>}
        <div className='d-flex justify-content-center'>
          <CardGroup style={{maxWidth: '900px'}}>
          {magazine.map((item, index) => (
            <div className='p-2' key={index}>
              <Card style={{width:"600px"}}>
                <Card.Img className='img-responsive' variant="top" src={`${config.s3.imageUrl}website/kanal/${item.prgID}/${item.reportID}/${item.img}`} style={{height:"350px"}} />
                <Card.Body>
                  <Card.Title style={{height:"auto", fontFamily:"", paddingBottom:4}}>
                    <h4 className="mb-1" style={{fontWeight:600, fontSize:'1.25rem', margin:0}}>{item.Title || item.reportName || item.prgName || item.issue || 'Magazine Issue'}</h4>
                    {item.reportDate && (
                      <small className="text-muted" style={{display:'block'}}>{new Date(item.reportDate).toLocaleString('default',{month:'short', year:'numeric'})}</small>
                    )}
                  </Card.Title>
                  <Card.Text className='max-lines' style={{color:'#444', fontSize:'1rem', lineHeight:1.5, marginTop:8}}>
                    {item.desc || ''}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <PdfViewing data={item}  url={`${config.s3.imageUrl}website/kanal/${item.prgID}/${item.reportID}/${item.pdfUrl}`}/>
                </Card.Footer>
              </Card>
            </div>
          ))}
          {!loading && magazine.length === 0 && !error && (
            <div className='text-muted p-3'>No magazine issues available.</div>
          )}
          </CardGroup>
        </div>
    </Row>
         <Row>
        <Col className='text-center md-8'>
          <h2 className='my-4' style={{fontWeight:"500"}}>மாணவர் படைப்பு</h2>
        <CardGroup >
          {studentCreation2.map((item, index) => (
            <div className='p-2'>
              <Card >
                <Card.Img className='img-responsive' variant="top" src={item.img} style={{height:"400px"}} />
                <Card.Body>
                  <Card.Title style={{height:"50px", fontWeight:"500", fontFamily:""}}><h4>{item.Title} </h4></Card.Title>
                  <Card.Text className='max-lines'>
                    <h4>
                      {item.Description}
                    </h4>
                    
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
         {/* <Button variant="primary" href={'/'} target="_blank">View</Button> */}
           
        <PdfViewing data={studentCreation2} selectedIndex={index} />
        </Card.Footer>
              </Card>
            </div>
          ))}
        </CardGroup>
      </Col>
      <Col className='text-center md-4'>
        <h2 className='my-4' style={{fontWeight:"500"}}>மாணவர் படைப்பு</h2>
        <CardGroup>
          {studentCreation.map((item, index) => (
            <div className='p-2'>
              <Card>
                <Card.Img className='img-responsive' variant="top" src={item.img} style={{height:"400px"}} />
                <Card.Body>
                  <Card.Title style={{height:"50px", fontWeight:"500", fontFamily:""}}><h4>{item.Title} </h4></Card.Title>
                  <Card.Text className='max-lines'>
                    <h4>
                      {item.Description}
                    </h4>
                    
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          ))}
        </CardGroup>
      </Col>
         </Row>
    
       
        
    </div>
  )
}
